import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _obj;
import Controller from "@ember/controller";
import discourseComputed from "discourse-common/utils/decorators";
export default Controller.extend((_dec = discourseComputed("model.watching_tags.[]", "model.watching_first_post_tags.[]", "model.tracking_tags.[]", "model.regular_tags.[]", "model.muted_tags.[]"), (_obj = {
  selectedTags(watching, watchingFirst, tracking, regular, muted) {
    return [].concat(watching, watchingFirst, tracking, regular, muted).filter(t => t);
  }
}, (_applyDecoratedDescriptor(_obj, "selectedTags", [_dec], Object.getOwnPropertyDescriptor(_obj, "selectedTags"), _obj)), _obj)));